module.exports = __webpack_public_path__ + "static/media/0321_Medium.70d007e9.jpg";